import { useCallback } from "react";

import { type SetterOrUpdater, useRecoilState } from "recoil";

import { type SubmitLensState } from "../models";
import { submitLensStateAtom } from "../state";

export const useSubmitLensConfiguration = (): {
    submitLensState: SubmitLensState;
    setSubmitLensState: SetterOrUpdater<SubmitLensState>;
    setSubmitUnderDifferentUser: (submitUnderDifferentUser: boolean) => void;
    setIsExclusiveLens: (isExclusiveLens: boolean) => void;
} => {
    const [submitLensState, setSubmitLensState] = useRecoilState(submitLensStateAtom);

    const setSubmitUnderDifferentUser = useCallback(
        (submitUnderDifferentUser: boolean) => {
            setSubmitLensState({ ...submitLensState, submitUnderDifferentUser });
        },
        [submitLensState, setSubmitLensState],
    );

    const setIsExclusiveLens = useCallback(
        (isExclusiveLens: boolean) => {
            setSubmitLensState({ ...submitLensState, isExclusiveLens });
        },
        [submitLensState, setSubmitLensState],
    );

    return {
        submitLensState,
        setSubmitLensState,
        setSubmitUnderDifferentUser,
        setIsExclusiveLens,
    };
};
